<template>
  <div id="app" ref="app" :class="`brand-${$brand.id}`">
    <PCNavbar v-if="showSiteNav" :selectIndex="activeNavIndex" />
    <router-view></router-view>
    <CallMe v-if="showSiteFooter" />
    <MobileCallme v-if="showSiteFooter" />
    <BackTop />
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'

export default {
  name: 'App',
  components: {
    PCNavbar,
  },
  computed: {
    showSiteNav() {
      return !this.$route.path.startsWith('/controlCenter')
    },
    showSiteFooter() {
      return !this.$route.path.startsWith('/controlCenter')
    },
    activeNavIndex() {
      const path = this.$route.path
      if (path.startsWith('/production')) return '2-1'
      if (path.startsWith('/news')) return '3'
      if (path.startsWith('/faq')) return '7'
      if (path.startsWith('/company')) return '8'
      if (path.startsWith('/home') || path === '/') return '1'
      return ''
    },
  },
  watch: {
    $route() {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
  },
}
</script>

<style lang="scss">
* {
  box-sizing: border-box;
}

html,
body,
#app {
  min-height: 100%;
}

html,
body {
  max-width: 100%;
  overflow-x: hidden;
}

img,
video,
canvas,
svg {
  max-width: 100%;
}

img[src*="/brands/"] {
  object-fit: contain;
}

button,
input,
select,
textarea {
  font: inherit;
}

@import url('./assets/css/icon.css');
@import url('./assets/css/responsive.css');

.el-message {
  top: 24px !important;
  left: 24px !important;
  right: auto !important;
  transform: none !important;
  min-width: 360px;
  max-width: min(520px, calc(100vw - 48px));
  padding: 18px 22px;
  align-items: flex-start;
  border-radius: 8px;
  border-width: 1px;
  border-style: solid;
}

.el-message .el-message__icon {
  margin-top: 2px;
  font-size: 22px;
}

.el-message .el-message__content {
  font-size: 18px;
  line-height: 1.45;
  word-break: break-word;
}

.el-message.el-message--success {
  background: #ecfdf3;
  border-color: #86efac;
  box-shadow: 0 16px 40px rgba(20, 83, 45, 0.18);
}

.el-message.el-message--success,
.el-message.el-message--success .el-message__content,
.el-message.el-message--success .el-message__icon {
  color: #166534;
}

.el-message.el-message--error {
  background: #fef2f2;
  border-color: #fca5a5;
  box-shadow: 0 16px 40px rgba(153, 27, 27, 0.18);
}

.el-message.el-message--error,
.el-message.el-message--error .el-message__content,
.el-message.el-message--error .el-message__icon {
  color: #991b1b;
}

.el-message.el-message--warning {
  background: #fffbeb;
  border-color: #fcd34d;
  box-shadow: 0 16px 40px rgba(146, 64, 14, 0.18);
}

.el-message.el-message--warning,
.el-message.el-message--warning .el-message__content,
.el-message.el-message--warning .el-message__icon {
  color: #92400e;
}

.el-message.el-message--info {
  background: #eff6ff;
  border-color: #93c5fd;
  box-shadow: 0 16px 40px rgba(30, 64, 175, 0.18);
}

.el-message.el-message--info,
.el-message.el-message--info .el-message__content,
.el-message.el-message--info .el-message__icon {
  color: #1e40af;
}

@media (max-width: 768px) {
  .el-message {
    top: 16px !important;
    left: 16px !important;
    min-width: 0;
    width: calc(100vw - 32px);
    max-width: calc(100vw - 32px);
    padding: 15px 16px;
  }

  .el-message .el-message__icon {
    font-size: 20px;
  }

  .el-message .el-message__content {
    font-size: 16px;
  }
}
</style>
